define('app/logging',['moment'], function (moment) {
    // Set up our logging.
    var messages = [];
    var mods = [];

    // Record a log message
    window.log = function (msg) {
        messages.push({ msg: msg, date: moment() });
    };

    // Print all log messages
    window.getLog = function () {
        console.log('%cLog:', 'color: #009900; font-size: 1.5em; text-decoration: underline;');

        messages.forEach(function (msg) {
            if (!window.console || !window.console.log) return;

            console.log('[' + msg.date.format('H:m:s.S D/MM/YYYY') + '] - ' + msg.msg);
        });
    }

    // Record a module loading.
    window.loadedModules = function (m) {
        mods.push({ m: m, date: moment() });
    };

    // Print all loaded modules.
    window.getLoadedModules = function () {
        if (!window.console || !window.console.log) return;

        console.log('%cLoaded modules:', 'color: #6699ff; font-size: 1.5em; text-decoration: underline;');

        mods.forEach(function (m) {
            console.log('* [' + m.date.format('H:m:s.S D/MM/YYYY') + '] - ' + m.m);
        });
    }

    if (!window.console || !window.console.log) return;
    window.console.log('Available commands: getLog, log(msg), getLoadedModules, loadedModules(m)');
});
